/*
 * @Author: Witt
 * @Date: 2018-10-29 10:26:58
 * @Last Modified by: Witt
 * @Last Modified time: 2018-10-29 15:49:12
 */
import { ControlValueConverter } from '@farris/devkit';

/**
 * å¤è¯­è¨è½¬æ¢å¨
 */
class MultiLangConverter implements ControlValueConverter {

  /**
   * æé å½æ°
   */
  constructor() {
  }

  /**
   * å°æ°æ®æºä¸­çåå§å¼=>å¤è¯­æ§ä»¶è¯å«çå¯¹è±¡å¼
   */
  public convertFrom(value: string): any {
    const multiLangControlValue = Object.assign({}, value);
    return multiLangControlValue;
  }

  /**
   * å¤è¯­æ§ä»¶è¯å«çå¯¹è±¡å¼=>å°æ°æ®æºä¸­çåå§å¼
   */
  public convertTo(multiLangControlValue: any): any {
    const value = multiLangControlValue;
    return value;
  }

}
export { MultiLangConverter };
